var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',{attrs:{"color":_vm.activeLink ? 'primary' : 'dark',"type":_vm.activeLink ? 'filled' : 'border',"icon-pack":"feather","icon":_vm.icon,"size":_vm.size},on:{"click":_vm.navigate}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }